import ProviderLayout from '../layout/ProviderLayout';
import Dashboard from '../provider/dashboard/dashboard';
import ProviderProfile from '../provider/providerProfile/ProviderProfile';
import UpdateProfile from "../provider/providerProfile/updateProfile";
import JobHistoryProvider from "../provider/jobHistory/JobHistoryProvider";
import JobDetailProvider from "../provider/jobDetail/JobDetailProvider";
import JobRequest from '../provider/jobHistory/JobRequest';
import JobDetails from '../provider/jobDetail/JobDetails';
import JobDeliveryStatus from '../provider/jobHistory/JobDeliveryStatus';
import ShareReQuote from '../provider/shareReQuote/ShareReQuote';
import TransactionHistory from '../components/managePayment/TransactionHistory';
import Viewrating from '../provider/viewrating/Viewrating';
import Chat from "../components/userChat/Userchat"
import NotificationList from '../components/notification/NotificationList';
import UserProfile from '../provider/userProfile/UserProfile';
import PublicLayout from '../layout/PublicLayout';
import CallbackComponent from '../components/authCallback/CallbackComponent';
import Availabilty from '../provider/availability/Availability';
import ShareFinalQuote from '../provider/shareFinalQuote/ShareFinalQuote';
// Route Views

const providerRoutes = [
  {
    path: '/provider/dashboard',
    exact: true,
    layout: ProviderLayout,
    component: <Dashboard />
  },
  {
    path: '/provider/profile',
    exact: true,
    layout: ProviderLayout,
    component: <ProviderProfile />
  },
  {
    path: '/provider/viewrating',
    exact: true,
    layout: ProviderLayout,
    component: <Viewrating />
  },
  {
    path: '/provider/update',
    exact: true,
    layout: ProviderLayout,
    component: <UpdateProfile />
  },
  {
    path: '/provider/accountsetting',
    exact: true,
    layout: ProviderLayout,
    component: <UserProfile />
  },
  {
    path: '/provider/jobs',
    exact: true,
    layout: ProviderLayout,
    component: <JobHistoryProvider />
  },
  {
    path: '/provider/jobdetail',
    exact: true,
    layout: ProviderLayout,
    component: <JobDetailProvider />
  },
  {
    path: '/provider/jobrequest',
    exact: true,
    layout: ProviderLayout,
    component: <JobRequest />
  },
  {
    path: '/job/detail',
    exact: true,
    layout: ProviderLayout,
    component: <JobDetails />
  },
  {
    path: '/job/delivery-status',
    exact: true,
    layout: ProviderLayout,
    component: <JobDeliveryStatus />
  },
  {
    path: '/job/share-requote',
    exact: true,
    layout: ProviderLayout,
    component: <ShareReQuote />
  },
  {
    path: '/transaction-history',
    exact: true,
    layout: ProviderLayout,
    component: <TransactionHistory />
  },
  {
    path: '/chat',
    exact: true,
    layout: ProviderLayout,
    component: <Chat />
  },
  {
    path: '/notification-list',
    exact: true,
    layout: ProviderLayout,
    component: <NotificationList />
  },
  {
    path: '/auth/callback',
    exact: true,
    layout: PublicLayout,
    component: <CallbackComponent />
  },
  {
    path: '/job/job-update',
    exact: true,
    layout: PublicLayout,
    component: < Availabilty/>
  },
  {
    path: '/job/share-finalquote',
    exact: true,
    layout: ProviderLayout,
    component: <ShareFinalQuote />
  },
];

export default providerRoutes;
